module.exports = {"id":"dp4_3l3q3","text":"Supporting Wellbeing","instructions":"Digital platforms can amplify harmful behaviour or content through design choices such as recommendation systems.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.3","questionType":"PickOne","random":false,"options":[{"id":"dp4_3l3q3-a1","text":"True","score":3.7},{"id":"dp4_3l3q3-a2","text":"Not sure","score":1.3},{"id":"dp4_3l3q3-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.3/l3q3.json
// module id = 1252
// module chunks = 41